<h2 class="title" mat-dialog-title>{{ 'camera.label' | translate }}</h2>
<mat-dialog-content>
    <div *ngIf="unsupported; else supported" class="no-device">
        <mat-icon class="m-0 camera-icon mb-3">support_agent</mat-icon>
        <p class="error">{{ 'camera.unsupported' | translate }}</p>
    </div>
    <ng-template #supported>
        <div *ngIf="nodevice; else deviceFound" class="no-device">
            <mat-icon class="m-0 mb-3 camera-icon">no_photography</mat-icon>
            <p class="mb-3">{{ 'camera.no_connected' | translate }}</p>
            <button mat-button class="m-button-primary" (click)="initCamera()">
                <mat-icon>refresh</mat-icon> {{ 'action.recheck' | translate }}
            </button>
        </div>
        <ng-template #deviceFound>
            <div class="camera-container">
                <ng-container *ngIf="imageSource; else cameraBlock">
                    <img [src]="imageSource">
                    <div class="camera-control">
                        <button mat-icon-button class="camera-capture" (click)="onReset()">
                            <mat-icon>replay</mat-icon>
                        </button>
                        <button mat-icon-button class="camera-capture approve" (click)="onDone()">
                            <mat-icon>check</mat-icon>
                        </button>
                    </div>
                </ng-container>
                <ng-template #cameraBlock>
                    <video autoplay #cameraView (loadedmetadata)="onVideoMetaDataLoaded()"></video>
                    <div class="camera-control">
                        <button mat-icon-button class="camera-capture" (click)="onCapture()">
                            <mat-icon>photo_camera</mat-icon>
                        </button>
                    </div>
                </ng-template>
            </div>

            <div class="row gap-3 mb-0 mt-3">
                <div class="m-form form-group col-6 px-0 mb-0">
                    <label>{{ 'camera.devices' | translate }}</label>
                    <app-select [disabled]="loading" [value]="selectedCamera" (selectChange)="onDeviceSelectionChange($event)">
                        <app-option *ngFor="let device of devices; index as i" [value]="device.deviceId">
                            {{ device.label || "Device - " + (i + 1) }}
                        </app-option>
                    </app-select>
                </div>
                <div class="m-form form-group col-5 px-0 mb-0">
                    <label>{{ 'camera.resolution' | translate }}</label>
                    <app-select [disabled]="loading" [value]="resolution" (selectChange)="onResolutionSelectionChange($event)">
                        <app-option *ngFor="let resolu of RESOLUTIONS | keyvalue: originalOrder" [value]="resolu.key">
                            {{ resolu.value.width.exact }} &times; {{ resolu.value.height.exact }}
                        </app-option>
                    </app-select>
                </div>
            </div>
        </ng-template>
    </ng-template>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-stroked-button mat-dialog-close class="m-button-outlined"><mat-icon>logout</mat-icon> {{ 'button.close' | translate }}</button>
</mat-dialog-actions>
